export enum DepartmentSidebarSteps {
  deptName = "deptName",
  chooseMembers = "chooseMembers",
}
